import React from "react";
import {Typography} from "@mui/material";
import {FormattedMessage} from "react-intl";
import {useGetMLBPlayerSeasonStatsByPlayerIdQuery} from "../../../stores/tradefan/tradefan.api";

import "../SeasonStats.style.scss";

    const renderPitcherStats = (data) => {
        return <div className="seasonStats">
            <div className="statItem">
                <div>{data.GamesPlayed}</div>
                <div>GP</div>
            </div>
            <div className="statItem">
                <div>{data.InningsPitched}</div>
                <div>IP</div>
            </div>
            <div className="statItem">
                <div>{data.Wins}-{data.Losses}</div>
                <div>W-L</div>
            </div>
            <div className="statItem">
                <div>{data.EarnedRunsAverage}</div>
                <div>ERA</div>
            </div>
            <div className="statItem">
                <div>{data.Strikeouts}</div>
                <div>SO</div>
            </div>
            <div className="statItem">
                <div>{data.TotalStrikeoutsPG}</div>
                <div>TSO/GM</div>
            </div>
        </div>
    }

const renderBatterStats = (data) => {
    return <div className="seasonStats">
        <div className="statItem">
            <div>{data.GamesPlayed}</div>
            <div>GP</div>
        </div>
        <div className="statItem">
            <div>{data.Hits}</div>
            <div>H</div>
        </div>
        <div className="statItem">
            <div>{data.HittingAverage}</div>
            <div>AVG</div>
        </div>
        <div className="statItem">
            <div>{data.HomeRuns}</div>
            <div>HR</div>
        </div>
        <div className="statItem">
            <div>{data.RunsBattedIn}</div>
            <div>RBI</div>
        </div>
        <div className="statItem">
            <div>{data.TotalHittingDraftPG}</div>
            <div>THD/GM</div>
        </div>
    </div>
}

const MLBSeasonStats = ({playerId, isPitcher, seasonYears}) => {
    const {data} = useGetMLBPlayerSeasonStatsByPlayerIdQuery({playerId, seasonYear: seasonYears[0]});

    return (
        <div className="MLBSeasonStats">
            <Typography variant="h6" className="statsTitle">
                {seasonYears[0]} - {seasonYears[1]} <FormattedMessage id={"popUp.contestPreview.seasonStats"}/>
            </Typography>
            {isPitcher ? renderPitcherStats(data) : renderBatterStats(data)}
        </div>
    )
}

export default MLBSeasonStats;